// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3fFGd","disabled":"FileBtn_disabled__34QqN","warn":"FileBtn_warn__3IUdB","fade":"FileBtn_fade__rPbbo"};